/**
 * The native compatibility level of the installed iOS binary.
 *
 * `client/ota.config.json` `nativeBuild` is the single source: capacitor.config.ts
 * bakes it into the updater's builtin version as `native+<level>`, and every OTA
 * bundle built afterwards requires at least that level (`minNativeBuild` in the
 * manifest). It is not the TestFlight build number, which App Store Connect
 * assigns on upload.
 *
 * Binaries uploaded before this existed (builds 1–3) have no `+<level>` suffix;
 * for those the CFBundleVersion was the level, so it is the fallback.
 */
export function parseNativeLevel(builtinVersion: string | undefined, bundleBuild: string): number {
  const match = builtinVersion?.match(/\+(\d+)$/);
  if (match) return Number(match[1]);
  const build = Number(bundleBuild);
  return Number.isFinite(build) ? build : 0;
}
